// import logo from './logo.svg';
// import './index.css';
// import { BrowserRouter } from 'react-router-dom'
// import {AppRoute} from './Routes/AppRoute'

// function App() {


//   return (
//     <>
//       <BrowserRouter>
//         <AppRoute />
//       </BrowserRouter>
//     </>
//   )
// }



// export default App;

import { useEffect } from "react";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { AppRoute } from "./Routes/AppRoute";
import { getUrlParams } from "./apiService/timespam";
import i18n from "./i18n";

function App() {
  useEffect(() => {
    const { theme, lang } = getUrlParams();
    const root = document.documentElement; // <html>

    // Apply language and RTL
    i18n.changeLanguage(lang);
    root.lang = lang;
    root.dir = lang === "ar" ? "rtl" : "ltr";

    // 1️⃣ URL param has highest priority
    if (theme === "dark") {
      root.classList.add("dark");
      return;
    }

    if (theme === "light") {
      root.classList.remove("dark");
      return;
    }

    // 2️⃣ Fallback to device theme
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;

    root.classList.toggle("dark", prefersDark);
  }, []);

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppRoute />
    </BrowserRouter>
  );
}

export default App;
